module.exports = __webpack_public_path__ + "img/image 09.6e79fb86.png";